var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotateArrowThird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 14 14",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(0 1 -1 0 16 -1.839827)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.333333 5.583428v-2.58612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.919453 2.997308h-2.58612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5518375 3.517245c2.6023283 1.23331736 3.9695238 4.13449495 3.2641827 6.9265692-.7053411 2.7920742-3.2863738 4.6958401-6.16222256 4.5452461-2.87584873-.150594-5.24392889-2.3135206-5.65379764-5.1639928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.9944 2.9973525c-.00002486.02069796-.01681451.03746187-.03751249.03745496s-.03747644-.01678202-.03748748-.03747999c-.00001104-.02069798.01674951-.03749098.03744747-.03751997.00996251-.00001395.01952111.00393695.02656638.01098081.00704527.00704387.01099808.01660167.01098612.02656419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.32773 3.99735c-.00002485.02069894-.01681603.03746325-.03751498.03745497-.02069896-.00000828-.03747671-.01678603-.03748499-.03748499-.00000828-.02069895.01675603-.03749013.03745497-.03751498.00996121-.00001196.01951788.00393982.02656153.01098347s.01099543.01660032.01098347.02656153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.3375 6.33069c-.00002899.02069796-.01682199.03745851-.03751997.03744747-.02069797-.00001104-.03747308-.0167895-.03747999-.03748748s.016757-.03748763.03745496-.03751249c.00996252-.00001196.01952032.00394085.02656419.01098612.00704386.00704527.01099476.01660387.01098081.02656638"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 18v-18h18v18z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateArrowThird);
export default __webpack_public_path__ + "static/media/rotate-arrow-third.1ed5d91eae5c1bef97a6391be092dfc2.svg";
export { ForwardRef as ReactComponent };